module.exports = __webpack_public_path__ + "static/rosary-thekkekara-28759e14a7910103504bfc0946e3e7af.png";